import { useTranslations } from "next-intl";

import { cn } from "@/utils/cn";
import { CallButton } from "@/widgets/Call";
import { CallBack } from "@/widgets/CallBack";
import { WriteButton } from "@/widgets/Write";

interface ObjectDetailActionsProps {
  className?: string;
  objectTitle?: string;
  objectId?: string;
  objectUrl?: string;
}

export function ObjectDetailActions({
  className,
  objectTitle,
  objectId,
  objectUrl,
}: ObjectDetailActionsProps) {
  const t = useTranslations();

  // Generate WhatsApp message
  const whatsappMessage = `${t("Hello")}. ${t("I am interested in")} ${objectTitle || ""} [${objectId || ""}]: ${objectUrl || ""}`;

  return (
    <div className={cn("flex flex-wrap gap-8", className)}>
      <div
        className={
          "w-full sm:w-auto grow shrink-0 basis-[15rem] xl:basis-[20rem]"
        }
      >
        <CallButton
          id={objectId || ""}
          buttonProps={{
            color: "red",
            variant: "solid",
            className: "font-bold",
            iconSize: 26,
          }}
        />
      </div>

      <div
        className={
          "w-full sm:w-auto grow shrink-0 basis-[15rem] xl:basis-[20rem]"
        }
      >
        <WriteButton
          id={objectId || ""}
          buttonProps={{
            className: "font-bold",
            iconSize: 26,
          }}
          message={whatsappMessage}
        />
      </div>

      <CallBack className="w-full grow shrink-0 sm:w-auto xl:px-8" />
    </div>
  );
}
